// extracted by mini-css-extract-plugin
export var content = "till-minne-module--content--3xGB5";
export var sectionTitle = "till-minne-module--sectionTitle--3OB9r";
export var dogTray = "till-minne-module--dogTray--2-R_S";
export var info = "till-minne-module--info--k1HXP";
export var left = "till-minne-module--left--34CfM";
export var right = "till-minne-module--right--2kGT9";
export var dogTrayInfo = "till-minne-module--dogTrayInfo--2XWAe";